// @ts-nocheck
import { workflowDrivenCacheSyncActionCreator } from '@ispm/workflow/utils/store.utils';
import * as immutable from 'immutable';
import { Idrug } from '../interfaces/drug.interface';
import { AGeneralActionCreator } from '@ispm/core/classes/general-action-creator.abstract';
import { ITreatmentGlobalConf } from '@ispm/therapies/interfaces/view-configuration.interface';
import { AWorkflowDrivenAction } from '@ispm/workflow/classes/workflow-driven-action.abstract';

export const THERAPIES_ACTIONS = {
  'SET_TRIALS': '[Treatments] SET_TRIALS',
  'SET_TREATMENTS': '[Treatments] SET_TREATMENTS',
  'SET_THERAPIES': '[Treatments] SET_THERAPIES',
  'SET_UNCHARACTERIZEDTHERAPIES': '[Treatments] SET_UNCHARACTERIZEDTHERAPIES',
  'SET_NOT_SENT_FOR_INTERPRETATION_THERAPIES': '[Treatments] SET_NOT_SENT_FOR_INTERPRETATION_THERAPIES',
  'SET_PROVIDERS': '[Treatments] SET_PROVIDERS',
  'SET_CLINICALRECOMMENDATIONS': '[Treatments] SET_CLINICALRECOMMENDATIONS',
  'APPEND_CLINICALRECOMMENDATIONS': '[Treatments] APPEND_CLINICALRECOMMENDATIONS',
  'SET_UNCHARACTERIZEDCLINICALRECOMMENDATIONS': '[Treatments] SET_UNCHARACTERIZEDCLINICALRECOMMENDATIONS',
  'UPDATE_REVIEW': '[Treatments] UPDATE_REVIEW',
  'SET_ANY_RESOURCES': '[Treatments] SET_ANY_RESOURCES',
  'SET_PERMITTED_ACTIONS': '[Treatments] SET_PERMITTED_ACTIONS',

  'UPDATE_RATIONALE': '[Treatments] UPDATE_RATIONALE',
  'INIT_REVIEW': '[Treatments] INIT_REVIEW',

  // Opinion Actions to manage aberration visibility selections
  'SET_OPINION': '[Treatments] SET_OPINION',

  // priority list actions
  'CHANGE_ORDER': '[Treatments] CHANGE_ORDER',
  'ADD_THERAPY_TO_PRIORITY_LIST': '[Treatments] ADD_THERAPY_TO_PRIORITY_LIST',
  'REMOVE_THERAPY_FROM_PRIORITY_LIST': '[Treatments] REMOVE_THERAPY_FROM_PRIORITY_LIST',
  'SET_PRIORITY_LIST': '[Treatments] SET_PRIORITY_LIST',
  'UPDATE_ITEM_PRIORITY_LIST': '[Treatments] UPDATE_ITEM_PRIORITY_LIST',
  'UPDATE_TREATMENT': '[Treatments] UPDATE_TREATMENT_ITEM',
  'UPDATE_CLINICALRECOMMENDATIONS': '[Treatments] UPDATE_CLINICALRECOMMENDATIONS',
  'UPDATE_TREATMENT_WORKFLOW_DRIVEN': '[Treatments] UPDATE_TREATMENT ITEM WORKFLOW DRIVEN',
  'SET_REVIEWS': '[Treatments] SET_REVIEWS',
  'SET_CASE_STATUS': '[Treatments] SET_CASE_STATUS',
  'INIT_THERAPY_STATE': '[Treatments] INIT_THERAPY_STATE',
  'ADD_REVIEWS': '[Treatments] ADD_REVIEWS',
  'SET_GLOBAL_CONF': '[Treatments] Set global configurations',
  'CLEAR_CLINICALRECOMMENDATIONS': '[Treatments] CLEAR_CLINICALRECOMMENDATIONS'
};

export const initialUserReview = {
  caseStatus: false,
  rationale: '',
  globalConfiguration: {
    maxSelections: -1
  },
  priority: <immutable.List<Idrug>> immutable.List(),
  therapiesIndex: <immutable.Set<string>> immutable.Set()
};
export const setClinicalRecommendationsActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.SET_CLINICALRECOMMENDATIONS);
export const setUncharacterizedClinicalRecommendationsActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.SET_UNCHARACTERIZEDCLINICALRECOMMENDATIONS);
export const appendClinicalRecommendationsActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.APPEND_CLINICALRECOMMENDATIONS);
export const clearClinicalRecommendationsActionCreator  = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.CLEAR_CLINICALRECOMMENDATIONS);
export const updateClinicalRecommendationActionCreator  = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.UPDATE_CLINICALRECOMMENDATIONS);

export const initTherapyStateActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.INIT_THERAPY_STATE);
export const addTherapyToPriorityListActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.ADD_THERAPY_TO_PRIORITY_LIST);
export const removeTherapyFromPriorityListActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.REMOVE_THERAPY_FROM_PRIORITY_LIST);
export const setTherapiesActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.SET_THERAPIES);
export const setUncharacterizedTherapiesActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.SET_UNCHARACTERIZEDTHERAPIES);
export const setNotSentForInterpretationTherapiesActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.SET_NOT_SENT_FOR_INTERPRETATION_THERAPIES);
export const setProvidersTherapiesActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.SET_PROVIDERS);
export const updateRationaleTherapiesActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.UPDATE_RATIONALE);
export const initReviewTherapiesActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.INIT_REVIEW);
export const changeOrderTherapiesActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.CHANGE_ORDER);

export const setTreatmentsActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.SET_TREATMENTS);
export const updateTreatmentActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.UPDATE_TREATMENT_WORKFLOW_DRIVEN);

export const setOpinionActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.SET_OPINION);
export const setTrialsActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.SET_TRIALS);
export const setPriorityListActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.SET_PRIORITY_LIST);
export const setReviewsActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.SET_REVIEWS);
export const addReviewsActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.ADD_REVIEWS);
export const setCaseStatusActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.SET_CASE_STATUS);
export const setAnyResourcesActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.SET_ANY_RESOURCES);
export const setPermittedActionsActionCreator = workflowDrivenCacheSyncActionCreator(THERAPIES_ACTIONS.SET_PERMITTED_ACTIONS);

export class TreatmentGlobalConfigurationsAction extends AGeneralActionCreator<ITreatmentGlobalConf> {

  readonly type: string = THERAPIES_ACTIONS.SET_GLOBAL_CONF;

  constructor(payload: Partial<ITreatmentGlobalConf>) {
    super(payload);
  }
}

export class UpdateTreatmentReviewAction extends AWorkflowDrivenAction<{ index: number, review: any}> {

  readonly type: string = THERAPIES_ACTIONS.UPDATE_REVIEW;

  constructor(index: number, review: any) {
    super({ index, review});
  }
}

export class UpdateItemInPriorityAction extends AWorkflowDrivenAction<{ index: number, value: any}> {

  readonly type: string = THERAPIES_ACTIONS.UPDATE_ITEM_PRIORITY_LIST;

  constructor(index: number, value: any) {
    super({ index, value});
  }
}

export class UpdateTreatmentPlanAction extends AWorkflowDrivenAction<{ value: any}> {

  readonly type: string = THERAPIES_ACTIONS.UPDATE_TREATMENT_WORKFLOW_DRIVEN;

  constructor(value: any) {
    super({ value});
  }
}
